var $10556a59bf2ddefc$exports = {};
$10556a59bf2ddefc$exports = {
    "backButton": (args)=>`N\xe1vrat na ${args.prevMenuButton}`,
    "moreActions": `Dal\u{161}\xed akce`,
    "unavailable": `Nen\xed k dispozici, rozbalen\xedm zobraz\xedte podrobnosti`
};


export {$10556a59bf2ddefc$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
